import InitKioskCustomerManager from './InitKioskCustomerManager'
export default InitKioskCustomerManager
